<template>
    <nav class="navbar z-index--20">
        <button
            class="hamburger hamburger--spin"
            :class="{ 'is-active': menuIsActive }"
            @click="toggleMenu"
        >
            <span class="hamburger-box">
                <span class="hamburger-inner"></span>
            </span>
        </button>

        <a :href="homepageUrl" class="logo" alt="Home">
            <logo></logo>
        </a>

        <div
            class="navbar__menu"
            :class="{ 'is-active': menuIsActive | searchIsActive }"
        >
            <ul class="navbar__links" :class="{ 'is-active': menuIsActive }">
                <li
                    v-for="(menuItem, index) in menuModel"
                    :key="index"
                    class="navbar__link"
                >
                    <a :href="menuItem.url">
                        {{ menuItem.title }}
                        <i
                            :class="{
                                'fa fa-chevron-down color--blue-7 ml-1':
                                    menuItem.childItems.length > 0
                            }"
                            aria-hidden="true"
                        >
                        </i>
                    </a>
                    <ul
                        v-if="menuItem.childItems.length > 0"
                        class="navbar__submenu"
                    >
                        <li
                            v-for="(childItem,
                            childIndex) in menuItem.childItems"
                            :key="childIndex"
                        >
                            <a :href="childItem.url">
                                <i
                                    class="fa fa-minus color--blue-7 mr-1"
                                    aria-hidden="true"
                                ></i>
                                {{ childItem.title }}
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>

            <div
                class="search__mobile"
                :class="{ 'is-active': searchIsActive }"
            >
                <h2 class="color--white text-center mb-4">
                    Verwondering ligt ook bij jou om de hoek!
                </h2>
                <div class="navbar__search mb-4 pr-2">
                    <input
                        v-model="searchInput"
                        class="search__input d-inline-block"
                        type="text"
                        placeholder="Zoeken"
                        @keydown.enter="executeMobileSearch"
                    />
                    <button>
                        <i class="fa fa-search" aria-hidden="true"></i>
                    </button>
                </div>

                <ul class="search__results">
                    <li
                        v-for="(result, index) in results.searchResults"
                        :key="index"
                        class="mb-2"
                    >
                        <a :href="result.url">
                            <h3>{{ result.title }}</h3>
                            <p>
                                {{ result.excerpt }}
                            </p>
                            <i class="fa fa-arrow-right" aria-hidden="true"></i>
                        </a>
                    </li>
                </ul>
            </div>

            <div class="navbar__icons">
                <i class="svg-icon__matroesjka"></i>
                <i class="svg-icon__clover"></i>
                <i class="svg-icon__gear"></i>
                <i class="svg-icon__robot"></i>
            </div>
        </div>

        <div class="navbar__login">
            <a :href="loginUrl" class="login" alt="login">
                <span v-if="user" class="navbar__login-text">{{
                    user.name
                }}</span>
                <span v-else class="navbar__login-text">Login</span>
                <i class="fa fa-user" aria-hidden="true"></i>
            </a>
        </div>

        <div class="navbar__search" @click="toggleSearch">
            <input
                ref="searchInput"
                v-model="searchInput"
                class="search__input"
                type="text"
                placeholder="Zoeken"
                @keydown.enter="executeSearch"
            />
            <button><i class="fa fa-search" aria-hidden="true"></i></button>
        </div>
    </nav>
</template>

<script>
import Logo from '@/components/logo';
import Axios from 'axios';

export default {
    components: {
        Logo
    },
    props: {
        menuModel: {
            type: Array,
            default() {
                return [];
            }
        }
    },

    data() {
        return {
            menuIsActive: false,
            searchIsActive: false,
            searchInput: '',
            url: '/api/search/searchurl',
            dataUrl: '/api/search/searchactivities',
            homepageUrl: '',
            loginUrl: '',
            results: []
        };
    },
    computed: {
        user() {
            return this.$store.state.user;
        }
    },
    created() {
        this.homepageUrl = window.location.origin;
        this.loginUrl = this.getLoginUrl();
    },
    methods: {
        toggleMenu() {
            this.searchIsActive = false;
            this.menuIsActive = !this.menuIsActive;
        },
        toggleSearch() {
            this.menuIsActive = false;
            this.searchIsActive = !this.searchIsActive;
        },
        executeSearch() {
            Axios.get(this.url)
                .then(response => {
                    window.location.href =
                        response.data + '?searchTerm=' + this.searchInput;
                })
                .catch(() => false);
        },
        executeMobileSearch() {
            Axios.get(this.dataUrl + '?searchTerm=' + this.searchInput)
                .then(response => {
                    this.results = response.data;
                })
                .catch(() => false);
        },
        getLoginUrl() {
            Axios.get('/clientdashboard/navigation/getloginurl')
                .then(response => {
                    this.loginUrl = response.data;
                })
                .catch(() => false);
        }
    }
};
</script>
